import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=fe5b4f56&scoped=true&lang=html"
import script from "./main-sidebar.vue?vue&type=script&lang=js"
export * from "./main-sidebar.vue?vue&type=script&lang=js"
import style0 from "./main-sidebar.vue?vue&type=style&index=0&id=fe5b4f56&prod&lang=css"
import style1 from "./main-sidebar.vue?vue&type=style&index=1&id=fe5b4f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5b4f56",
  null
  
)

export default component.exports